import React, { useEffect, useState } from "react";
import "../../styles/admins/user_profile.css";
import logo from "../../images/user.png";
import axios from "axios";

function MyProfile({ clientDetails, handleToast }) {
  const [formData, setFormData] = useState({
    staff_name: clientDetails.name || "",
    staff_id: clientDetails.staff_id || "",
    pass: clientDetails.pass || "",
    comp_id: clientDetails.company_id || "",
    contact: clientDetails.contact || "",
    email: clientDetails.email || "",
    designation: clientDetails.designation || "",
    department: clientDetails.department || "",
    staff_type: clientDetails.is_admin || "",
    assigned_item: clientDetails.item_id || "",
    assign_date: clientDetails.item_assign_date
      ? clientDetails.item_assign_date.split(" ")[0]
      : "",
    name: clientDetails.name || "",
    company_id: clientDetails.company_id || "",
    is_admin: clientDetails.is_admin || "",
    item_id: clientDetails.item_id || "",
    id: clientDetails.id || "",
    assign_comp: clientDetails.assign_comp,
    assigned_to: clientDetails.assigned_to,
    item_assign_date: clientDetails.item_assign_date
      ? clientDetails.item_assign_date.split(" ")[0]
      : "",
     priority: clientDetails.priority,
         olditem_id: clientDetails.item_id,

           image: null,
  currentImage: clientDetails.image || null ,
  });



  const [companies, setCompanies] = useState([]);
  const [items, setItems] = useState([]);

  // Fetch companies
  useEffect(() => {
    const getProducts = async () => {
      try {
        const response = await axios.get(
          "https://api.dectwinservices.com/api/products"
        );
        setItems(response.data);
      } catch (e) {
        handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    const getCompanies = async () => {
      try {
        const response = await axios.get(
          "https://api.dectwinservices.com/api/companies"
        );
        setCompanies(response.data);
      } catch (e) {
        handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getProducts();
    getCompanies();
  }, [handleToast]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit form data
  const handleSubmit = async (e) => {
    e.preventDefault();

const formDataToSend = new FormData();

Object.keys(formData).forEach((key) => {
  if (key === "image") {
    if (formData.image) {
      formDataToSend.append("image", formData.image);
    }
  } else {
    formDataToSend.append(key, formData[key]);
  }
});

    try {
      // await axios.put(
      //   "https://api.dectwinservices.com/api/update-user",
      //   formData
      // );

     
const response = await axios.put(
  "https://api.dectwinservices.com/api/update-user",
  formDataToSend,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);

      handleToast({
        toastMsg: "User Updated Successfully!!!",
        toastColor: "#4CAF50",
      });
      formData.name = formData.staff_name;
      localStorage.removeItem("users");
      localStorage.removeItem("exclserv_user");

      // localStorage.setItem("exclserv_user", JSON.stringify(formData));

      const updatedUser = {
  ...formData,
  image: response.data.image,   
  currentImage: response.data.image,
};

localStorage.setItem(
  "exclserv_user",
  JSON.stringify(updatedUser)
);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };


  

  return (
    <section className="profile px-4">
      <div className="left-side my-4"></div>
      <div className="right-side">
        
        <div className="top-profile p-3 text-md-start text-center">
<div className="row">
<div className="col-md-6 col-sm-6 col-12">
<img
  src={
    typeof formData.currentImage === "string" &&
    formData.currentImage
      ? formData.currentImage.startsWith("blob:")
        ? formData.currentImage
        : `https://api.dectwinservices.com/uploads/${formData.currentImage}`
      : logo
  }
  alt="Profile"
  className="profile-image"
/>
</div>

<div className="align-content-center name col-md-6 col-sm-6 col-12">
  <p>Hello, {clientDetails.name}</p>
      </div>
        </div>
</div>        

        <form className="add-prod-form edit-prof " onSubmit={handleSubmit}>
<div className="row">
            

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="staff_name">User Name</label>
            <div className="input-icon">
              <i className="bx bxs-layer"></i>
              <input
                type="text"
                name="staff_name"
                id="staff_name"
                value={formData.staff_name}
                onChange={handleChange}
                placeholder="Enter User Name"
                required
                disabled
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="staff_id">User ID</label>
            <div className="input-icon">
              <i className="bx bx-id-card"></i>
              <input
                type="text"
                name="staff_id"
                id="staff_id"
                value={formData.staff_id}
                onChange={handleChange}
                placeholder="Enter User ID"
                required
                 disabled
                // disabled={!!clientDetails.name}
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="pass">Create Password</label>
            <div className="input-icon">
              <i className="bx bxs-lock"></i>
              <input
                type="text"
                name="pass"
                id="pass"
                value={formData.pass}
                onChange={handleChange}
                placeholder="Create Password"
                required
                 disabled
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="comp_id">Select Company</label>
            <div className="input-icon">
              <i className="bx bxs-user"></i>
              <select
                name="comp_id"
                id="comp_id"
                value={formData.comp_id}
                onChange={handleChange}
                 style={{backgroundColor: 'var(--gray)'}}
                required
                disabled={!!clientDetails.name}
              >
                <option value="">Select Company</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.comp_id}>
                    {company.company_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="contact">User Contact</label>
            <div className="input-icon">
              <i className="bx bx-phone"></i>
              <input
                type="text"
                name="contact"
                id="contact"
                placeholder="Enter User Contact"
                value={formData.contact}
                onChange={handleChange}
                pattern="[0-9]*"
  maxLength={10}
   disabled
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="email">User Email</label>
            <div className="input-icon">
              <i className="bx bx-envelope"></i>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Enter User Email"
                value={formData.email}
                onChange={handleChange}
                 disabled
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="designation">User Designation</label>
            <div className="input-icon">
              <i className="bx bx-briefcase"></i>
              <input
                type="text"
                name="designation"
                id="designation"
                placeholder="Enter User Designation"
                value={formData.designation}
                onChange={handleChange}
                 disabled
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="department">Working Department</label>
            <div className="input-icon">
              <i className="bx bx-building"></i>
              <input
                type="text"
                name="department"
                id="department"
                placeholder="Working Department"
                value={formData.department}
                onChange={handleChange}
                 disabled
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="staff_type">User Role</label>
            <div className="input-icon">
              <i className="bx bxs-user-badge"></i>
              <select
                name="staff_type"
                 style={{backgroundColor: 'var(--gray)'}}
                id="staff_type"
                value={formData.staff_type}
                onChange={handleChange}
                required
                disabled
              >
                <option value="">Select User Role</option>
                <option value="Admin">Admin</option>
                <option value="Employee">Employee</option>
              </select>
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="assigned_item">Select Assigned Item</label>
            <div className="input-icon">
              <i className="bx bxs-package"></i>
              <select
               style={{backgroundColor: 'var(--gray)'}}
                name="assigned_item"
                id="assigned_item"
                value={formData.assigned_item}
                onChange={handleChange}
                required
                disabled
              >
                <option value="">Select Item</option>
                {items.map((item) => (
                  <option key={item.prod_id} value={item.prod_id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="assign_date">Assign Date</label>
            <div className="input-icon">
              <i className="bx bxs-calendar-check"></i>
              <input
                type="date"
                name="assign_date"
                id="assign_date"
                value={formData.assign_date}
                onChange={handleChange}
                disabled
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
  <label htmlFor="image">Profile Image</label>

  <div className="input-icon">
    <i className="bx bx-image"></i>

    <input
      type="file"
      id="image"
      accept="image/*"
      onChange={(e) => {
        const file = e.target.files[0];

        setFormData((prev) => ({
          ...prev,
          image: file,
          currentImage: URL.createObjectURL(file),
        }));
      }}
    />
  </div>
</div>

          <div
            className="form-data"
            style={{
              justifyContent: "flex-end",
              alignItems: "flex-end",
              paddingBottom: "10px",
            }}
          >
            <button
              style={{ width: "140px" }}
              type="submit"
              className="button-85"
            >
              Edit Profile
            </button>
          </div>
          </div>
        </form>
      </div>
    </section>
  );
}

export default MyProfile;
